export class queryFromHome {
    emailid:string;
    query :string;
    }